import { render } from "./AccountCardDetail.vue?vue&type=template&id=779220e6&scoped=true"
import script from "./AccountCardDetail.vue?vue&type=script&lang=js"
export * from "./AccountCardDetail.vue?vue&type=script&lang=js"

import "./AccountCardDetail.vue?vue&type=style&index=0&id=779220e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779220e6"]])

export default __exports__